import '../../styles/FormInput.css';
import * as React from 'react';

interface IValidationBlockProps {
    validationMessage: string;
    isValid: boolean;
    customClass?: string;
}

export const ValidationBlock = (props: IValidationBlockProps) => {
    if (props.isValid) {
        return null
    }
    return (
        <div className={props.customClass ? props.customClass : "input-container"}>
            <span className="valid-block" >{props.validationMessage}</span>
        </div>
    );
}


// WEBPACK FOOTER //
// ./src/components/FormControls/ValidationBlock.tsx